import { render } from "./ArcsPopUp.vue?vue&type=template&id=bcbe1a76"
import script from "./ArcsPopUp.vue?vue&type=script&lang=js"
export * from "./ArcsPopUp.vue?vue&type=script&lang=js"

import "./ArcsPopUp.vue?vue&type=style&index=0&id=bcbe1a76&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBar,QSpace,QBtn,QInnerLoading,QCircularProgress,QTooltip});
